import { Pagination } from '@/domain/entities/Pagination'

export class AdditionalInfoData {
  public id: number
  public title: string
  public fileCode: string
  public isActive: boolean
  public isDownloadable: boolean
  public isRecommended: boolean
  public Owner: string
  public file: Object
  public imageThumbnail: Object
  public imageCover: Object
  public createdAt: string
  public updatedAt: string
  public expireddate: string

  constructor(
    id: number,
    title: string,
    fileCode: string,
    isActive: boolean,
    isDownloadable: boolean,
    isRecommended: boolean,
    Owner: string,
    file: Object,
    imageThumbnail: Object,
    imageCover: Object,
    createdAt: string,
    updatedAt: string,
    expireddate: string
  ) {
    {
      this.id = id
      this.title = title
      this.fileCode = fileCode
      this.isActive = isActive
      this.isDownloadable = isDownloadable
      this.isRecommended = isRecommended
      this.Owner = Owner
      this.file = file
      this.imageThumbnail = imageThumbnail
      this.imageCover = imageCover
      this.createdAt = createdAt
      this.updatedAt = updatedAt
      this.expireddate = expireddate
    }
  }
}

export class AdditionalInfo {
  public success: boolean
  public message: string
  public pagination?: Pagination
  public data?: AdditionalInfoData[]

  constructor(
    success: boolean,
    message: string,
    pagination?: Pagination,
    data?: AdditionalInfoData[]
  ) {
    this.success = success
    this.message = message
    this.pagination = pagination
    this.data = data
  }
}
